export enum ToolbarType {
  Simple = 'simple',
  Regular = 'regular',
}
